import React, { useState } from 'react';
import { Button, EmptyState, FilterChips } from '@teals/ui-web';
import { Muted, Page, Subtitle, Title } from './modelsStyles';

const CLIENTS = [
  { id: 'cursor', label: 'Cursor' },
  { id: 'opencode', label: 'opencode' },
  { id: 'curl', label: 'curl' },
];

/**
 * Use models in your tools. The org switch defaults to off, so this page
 * explains the setup and does not mint a key until an owner turns the API on.
 */
const ModelConnect: React.FC = () => {
  const [client, setClient] = useState('cursor');
  return (
    <Page>
      <Title>Use models in your tools</Title>
      <Subtitle>Call your organisation&apos;s models from Cursor, opencode, or curl.</Subtitle>
      <FilterChips
        items={CLIENTS}
        activeId={client}
        onChange={setClient}
      />
      <EmptyState
        title="The Model API is off for this organisation"
        description="Owners and admins turn it on. Then you create a personal key (lf_mk_…). It is shown once, hashed after that, and can be revoked on the next request. Viewers can read this guide and cannot create keys."
        action={
          <Button variant="primary" disabled>
            Create a key
          </Button>
        }
      />
      <Muted>
        {client === 'curl'
          ? 'curl https://api.luminafactory.com/v1/openai/chat/completions -H "Authorization: Bearer lf_mk_…" -d \'{"model":"lumina-auto","messages":[{"role":"user","content":"Hello"}]}\''
          : client === 'opencode'
            ? 'Set the OpenAI-compatible base URL to https://api.luminafactory.com/v1/openai and paste the key as the API key.'
            : 'In Cursor, set the OpenAI base URL to https://api.luminafactory.com/v1/openai and paste the key. Streaming uses the Function URL behind that host.'}
      </Muted>
      <Muted>Requests count toward your organisation&apos;s allowance. Prompts and replies are not stored.</Muted>
    </Page>
  );
};

export default ModelConnect;
